import React, { forwardRef, useImperativeHandle, useState } from 'react';
import './index.less';
import { Upload } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { uploadFile } from '@/api/technical';
import { BaseResponseType } from '@/types/message';
import useUpload from '@/hooks/useUpload';
import { UploadFileSize } from '@/types/base';


interface UploadFileProps extends UploadFileSize {
  className?: string
  fileConfig?: UploadProps
  initFile?: any[]
  isCanUpload?: boolean
  acceptTip?: string
}


const { Dragger } = Upload;
const prefix = 'UploadFile';
const UploadFile = forwardRef((props: UploadFileProps,ref) => {
  const {
    className = "common-upload-file",
    singleSizeLimit = 20 * 1024,
    totalSizeLimit=100*1024,
    fileConfig = {},
    initFile = [],
    isCanUpload = true,
    acceptTip='仅支持PNG\\PDF\\ZIP\\word\\最大尺寸：20MB'
  } = props;

  useImperativeHandle(ref, () =>{
    return {
      getFiles: () => fileList
    }
  })

  const {
    fileList,
    onRemoveHandle,
    handleChange,
    uploadFileHandle,
    onDropHandle
  } = useUpload({
    initFile,
    singleSizeLimit,
    uploadFileAction: uploadFile
  });

  console.log('fileList', fileList);
  const totalSize= fileList.reduce((total, item) => item.size?total + item.size:total, 0);
  const data: UploadProps = {
    ...fileConfig,
    fileList,
    beforeUpload(file: any) {
      console.log('beforeUpload', file);
      if(!isCanUpload) return false;
      if (file.size > singleSizeLimit * 1024) {
        window.message.error(`单个附件大小不能超过${singleSizeLimit/1024}MB`);
        return false
      }
      if(totalSize+file.size>totalSizeLimit*1024){
        window.message.error(`附件总大小不能超过${totalSizeLimit/1024}MB`);
        return false
      }

      return true;
    },
    onRemove(file){
      if(!isCanUpload) return false;
      onRemoveHandle(file);
    },
    onChange(info: any) {
      if(!isCanUpload) return false;
      handleChange(info)
    },
    customRequest(options) {
      if(!isCanUpload) return false;
      uploadFileHandle(options);
    },
    onDrop(info) {
      if(!isCanUpload) return false;
      onDropHandle(info);
    }
  };
  return (
    <div>
      <Dragger className={`${className} ${isCanUpload ? '' : ' disabled-upload'}`}
        {...data}
      >

        <DownloadOutlined />
        <p className="ant-upload-hint">
          点击或拖拽文件至此区域
        </p>
        <p className="ant-upload-tip">{acceptTip}</p>
      </Dragger>
    </div>
  );
});
UploadFile.displayName = 'UploadFile';
export default React.memo(UploadFile);
